<template>
  <div class="page-game">
    <div class="shadow-tips-wrap" v-show="shareTipsVisible" @click="handleShareTipsClose">
      <div class="arrow-wrap">
        <img class="arrow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/tips-arrow.png">
        <div class="tips">点击右上角“...”进行分享</div>
      </div>
    </div>
    <div class="ready-wrap" v-if="gameStep===0">
      <img class="share-btn" @click="handleShareTipsShow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/share-btn.png"/>
      <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/top-title.png"/>
      <img class="complete-img" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/center-image.png"/>
      <div class="start-btn" @click="gameReady">
        <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/start-btn1.png"/>
      </div>
      <!-- <p>已有{{ gameInfo.joined_number }}人参与活动</p> -->
      <p class="bottom-tips">您今天还有{{ gameInfo.my_chance }}次参与机会</p>
      <div class="bottom-btn">
        <div class="btn" @click="toPage(3)">
          <img class="icon" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/rank-icon.png"/>
          <p>排行榜</p>
        </div>
        <div class="btn" @click="toPage(4)">
          <img class="icon" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/award-icon.png"/>
          <p>我的奖品</p>
        </div>
        <div class="btn" @click="toPage(2)">
          <img class="icon" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/rule-icon.png"/>
          <p>活动规则</p>
        </div>
      </div>
    </div>
    <div class="playing-wrap" v-if="gameStep===1">
      <div class="tools-bar">
        <img class="avatar" :src="userAvatar"/>
        <div class="time">时间<br/><span class="white">{{ gameTimeCost }}</span></div>
        <div class="music-wrap" @click="toggleBGM" :class="{active:BGMplaying}">
          <img class="border" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/music-border.png"/>
          <img class="music-btn" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/music-icon.png"/>
          <audio id="puzzle-game-bgm" style="display:none" src="https://wowsite.musicwow.com/mobile_musicwow/audio/puzzle-game-bgm.mp3" autoplay loop></audio>
        </div>
      </div>
      <div class="center-wrap">
        <img class="complete-image" v-show="gameTipsVisible" :src="`https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/puzzle${gameBackgroundIndex}-full.jpg`"/>
        <div class="puzzle-wrap" @touchmove="handlePuzzleTouchMove" @touchend="handlePuzzleTouchEnd">
          <div class="puzzle-item" @touchstart="(e)=>handlePuzzleTouchStart(e,index)" v-for="(item,index) in puzzleItemList" :key="index">
            <img class="shadow-img" :src="item.content"/>
            <img class="content" :src="item.content"/>
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="gameStart" v-show="!gamePlaying">
        <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/start-btn2.png"/>
      </div>
      <div class="bottom-btn" @click="gameTipsVisible=true" v-show="gamePlaying&&!gameTipsVisible">
        <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/tips-btn.png"/>
      </div>
      <div class="bottom-btn" @click="gameTipsVisible=false" v-show="gamePlaying&&gameTipsVisible">
        <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/start-btn2.png"/>
      </div>
    </div>
    <div class="result-wrap" v-if="gameStep===2">
      <img class="wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/search-wow.png"/>
      <img class="banner" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/success-banner.png"/> 
      <div class="content-wrap">
        <p class="result">您的成绩为:{{ gameResult.time }}秒</p>
        <p class="per">成功击败全国<span class="yellow">{{ gameResult.per }}%</span>的用户</p>
        <div class="rank-wrap">
          <div class="item l">
            <p>最佳成绩（秒）</p>
            <p class="num">{{ gameResult.best_time/1000 }}</p>
          </div>
          <div class="item r">
            <p>最佳排名</p>
            <p class="num">NO.{{ gameResult.best_rank }}</p>
          </div>
        </div>
        <div class="again-btn" v-if="gameResult.is_lottery===true" @click="toPage(1)">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/lottery-btn.png"/>
        </div>
        <div v-if="gameResult.is_lottery===false" class="again-btn">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/has-lottery-btn.png"/>
        </div>
      </div>
      <div class="bottom">
        <img class="btn" @click="toPage(3)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/to-rank-btn.png"/> 
        <img class="btn" @click="gameStep=0" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/to-home-btn.png"/> 
      </div>
    </div>
    <div class="result-wrap" v-if="gameStep===3">
      <img class="wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/search-wow.png"/>
      <img class="banner" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/fail-banner.png"/> 
      <div class="content-wrap">
        <p class="result">您的成绩为:{{ gameResult.time }}秒</p>
        <p class="per">成功击败全国<span class="yellow">{{ gameResult.per }}%</span>的用户</p>
        <div class="rank-wrap">
          <div class="item l">
            <p>最佳成绩（秒）</p>
            <p class="num">{{ gameResult.best_time/1000 }}</p>
          </div>
          <div class="item r">
            <p>最佳排名</p>
            <p class="num">NO.{{ gameResult.best_rank }}</p> 
          </div>
        </div>
        <p class="red-tips">成绩必须低于{{ gameTimeLimit/1000 }}秒才能抽奖</p>
        <div v-if="gameInfo.my_chance>0" @click="gameStep=0" class="again-btn">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/again-btn.png"/> 
        </div>
        <div v-if="gameInfo.my_chance===0&&gameResult.user_played_number<8" @click="handleShareTipsShow" class="again-btn">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/share-friend.png"/> 
        </div>
        <div v-if="gameInfo.my_chance===0&&gameResult.user_played_number>=8" class="again-btn">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/no-chance-btn.png"/> 
        </div>
        <p class="chance-number">您今天还有<span class="yellow">{{ gameInfo.my_chance }}</span>次参与机会</p>
      </div>
      <div class="bottom">
        <img class="btn" @click="toPage(3)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/to-rank-btn.png"/> 
        <img class="btn" @click="gameStep=0" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/to-home-btn.png"/> 
      </div>
      <div class="focus-wrap" @click="openSubscribeDialog">
        <img class="img" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/focus-us.png"/> 
        <p class="text">(请关注我们，更多活动及时通知)</p>
      </div>
    </div>
    <!-- 关注弹窗 -->
    <subscribe-dialog v-show="subscribeDialogVisible" @close="subscribeDialogVisible=false"></subscribe-dialog>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import CryptoJS from "crypto-js";
import subscribeDialog from "./subscribe.vue";
function banPageScroll(e){
  e.preventDefault();
}
export default {
  components:{
    subscribeDialog
  },
  props:['pageStep','puzzleId','orgId','passLimit','isEnd'],
  data(){
    return {
      shareTipsVisible: false,
      BGMplaying: false,
      gameStep: 0,// 游戏进程
      gameBackgroundIndex: 1,// 拼图图片组
      puzzleSize:[3,4],// x列，y行
      puzzleItemList:[],
      puzzleSelectStartIndex:0,
      puzzleSelectStartPosition:[0,0],
      puzzleSelectEndPosition:[0,0],
      gameInfo:{
        joined_number:0,// 已参加人数
        my_chance: 0,// 用户参与机会
        user_played_number:0,//  用户已参加次数
      },// 游戏信息
      gamePlaying: false,
      gameTipsVisible: true,
      gameStartTime: 0,// 游戏开始时间毫秒
      gameEndTime: 0,// 游戏结束时间毫秒
      gameTimeCost: 0,// 游戏已玩秒数
      gameTimer: null,// 游戏倒计时对象
      gameResult:{
        time:0,
        per:0,
        best_time:0,
        best_rank:0,
        is_lottery: false,// 能否抽奖
        user_played_number: 0,// 用户已参与次数
      },//游戏结果
      subscribeDialogVisible: false,
    }
  },
  computed:{
    gameTimeLimit(){
      return this.passLimit;
    }
  },
  watch:{
    pageStep(n){
      if(n===0){
        this.getGameInfo();
      }
    }
  },
  created(){
    // 获取游戏信息
    this.getGameInfo();
    // 微信分享，与原有配置错开，延后1s
    setTimeout(()=>{
      this.$ajax({
        method: "post",
        url: process.env.VUE_APP_CONT_API + "api/v1/wechat/js_config",
        headers: {
          "X-DEVICE-TYPE": "5",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          app_id: 'wx4d3ccd23d6464806',
          url: location.href
        }
      }).then((res) => {
        if (res.data.error_code == 0) {
          wx.config({
            appId: res.data.data.app_id,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonce_str,
            signature: res.data.data.signature,
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
          });
          wx.ready(function () {
            wx.updateTimelineShareData({
              title: '音乐窝六周年庆拼图赢大奖',
              link: location.href,
              imgUrl: 'https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/wx-share.jpg',
              success: function () {
                console.log("puzzle分享设置成功");
              },
            });
            wx.updateAppMessageShareData({
              title: '音乐窝六周年庆拼图赢大奖',
              desc: '轻轻松松就能赢奖品，积攒多年的人品终于有用了，你也赶紧来参与活动抽奖吧！',
              link: location.href,
              imgUrl: 'https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/wx-share.jpg',
              success: function () {
                console.log("puzzle分享设置成功");
              },
            });
          });
        }
      });
    },1000);
  },
  methods:{
    handleShareTipsShow(){
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/share`,
        method: "post",
        params:{
          puzzle_id: this.puzzleId,
          channel: this.orgId,
        }
      }).then(()=>{
        // 更新游玩机会
        this.getMyChance();
      });
      this.shareTipsVisible = true;
    },
    handleShareTipsClose(){
      this.shareTipsVisible = false;
    },
    getMyChance(){
      // 游戏信息
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/info?puzzle_id=${this.puzzleId}`,
        method: "get",
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.gameInfo = {
            joined_number: res.data.data.join_count,
            my_chance: res.data.data.user_playable_number,
            user_played_number: res.data.data.user_played_number,
          };
        }else if(res.data.error_code===18003003){
          // 账号在别的地方登录
          this.$toast(res.data.message);
          localStorage.setItem('mobile_musicwow_app_wx_token','');
          localStorage.setItem('mobile_musicwow_app_wx_user','');
          location.reload();
        }else{
          this.$toast(res.data.message);
        }
      });
    },
    getGameInfo(){
      // 用户头像
      if(!this.userAvatar){
        let userCache = localStorage.getItem('mobile_musicwow_app_wx_user');
        let userJSON = JSON.parse(userCache);
        let avatar = userJSON.avatar_url||'';
        this.userAvatar = avatar;
      }
      this.getMyChance();
      // 获取拼图图片组
      let random = Math.floor(Math.random()*7)+1;
      this.gameBackgroundIndex = random;
    },
    gameReady(){
      if(this.isEnd){
        this.$toast('活动已结束');
        return false;
      }
      if(this.gameInfo.my_chance===0){
        if(this.gameInfo.user_played_number>=8){
          this.$toast('今天挑战次数已用完，请明天再来');
          return false;
        }else{
          this.$toast('挑战次数已用完，分享页面可以获得额外挑战次数');
          return false;
        }
      }
      let random = Math.floor(Math.random()*7)+1;
      this.gameBackgroundIndex = random;
      this.gameTipsVisible = true;
      this.gamePlaying=false;
      this.gameTipsVisible=true;
      this.gameStartTime=0;
      this.gameEndTime=0;
      this.gameTimeCost=0;
      this.gameTimer=null;
      this.BGMplaying = true;
      this.gameStep = 1;
      this.puzzleItemList = [];
    },
    gameStart(){
      // 发起开始游戏请求
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/start`,
        method: "post",
        params:{
          puzzle_id: this.puzzleId,
          channel: this.orgId,
        }
      }).then((res) => {
        if (res.data.error_code === 0) {
          // 成功
          this.gameInfo.my_chance = this.gameInfo.my_chance-1;
          this.gameTipsVisible = false;
          this.gamePlaying = true;
          this.initPuzzle();
          if(this.gameTimer){
            clearInterval(this.gameTimer);
          }
          this.gameTimeCost = 0;
          this.gameStartTime = new Date().getTime();
          this.gameTimer = setInterval(()=>{
            this.gameTimeCost = this.gameTimeCost + 1;
          },1000);
        }else{
          this.$toast(res.data.message);
        }
      });
    },
    toggleBGM(){
      let el = document.getElementById('puzzle-game-bgm');
      if(this.BGMplaying){
        el.pause();
      }else{
        el.play();
      }
      this.BGMplaying = !this.BGMplaying;
    },
    initPuzzle(){
      let res = [];
      let cols = this.puzzleSize[0];
      let rows = this.puzzleSize[1];
      // 生成拼图组件
      for(let i=0;i<rows*cols;i++){
        let random = Math.floor(Math.random()*100000000);
        res.push({
          random: random,
          content:'https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/puzzle'+this.gameBackgroundIndex+'-part'+(i+1)+'.jpg',//图片地址
          index:i,// 真实序号
        });
      }
      // 根据随机数打乱
      res.sort((a,b)=>{
        return b.random-a.random;
      });
      this.puzzleItemList = res;
    },
    handlePuzzleTouchStart(e,index){
      //禁止页面拖动，防止漏顶
      document.addEventListener('touchmove', banPageScroll, { passive: false });
      this.puzzleSelectStartIndex = index;
      this.puzzleSelectStartPosition = [e.targetTouches[0].pageX,e.targetTouches[0].pageY];
    },
    handlePuzzleTouchMove(e){
      let el = document.querySelectorAll('.puzzle-wrap .puzzle-item .shadow-img')[this.puzzleSelectStartIndex];
      el.style.left = e.targetTouches[0].pageX-this.puzzleSelectStartPosition[0]+'px';
      el.style.top = e.targetTouches[0].pageY-this.puzzleSelectStartPosition[1]+'px';
      el.style.opacity = 0.5;
      this.puzzleSelectEndPosition = [e.targetTouches[0].pageX,e.targetTouches[0].pageY];
    },
    handlePuzzleTouchEnd(){
      document.removeEventListener('touchmove',banPageScroll);
      // 重置拖动样式
      document.querySelectorAll('.puzzle-wrap .puzzle-item .shadow-img').forEach((el)=>{
        el.style.left = '0px';
        el.style.top = '0px';
        el.style.opacity = '0';
      });
      let startX = this.puzzleSelectStartPosition[0];
      let startY = this.puzzleSelectStartPosition[1];
      let endX = this.puzzleSelectEndPosition[0];
      let endY = this.puzzleSelectEndPosition[1];
      let puzzleItemEl = document.querySelector('.puzzle-wrap .puzzle-item');
      let puzzleItemElW = puzzleItemEl.offsetWidth;
      let puzzleItemElH = puzzleItemEl.offsetHeight;
      // 判断位移
      let baseIndex = 0 + this.puzzleSelectStartIndex;
      if(endX-startX>0){
        // 右移
        if((endX-startX)/puzzleItemElW>1.5){
          baseIndex = baseIndex + 2;
        }else if((endX-startX)/puzzleItemElW>0.5){
          baseIndex = baseIndex + 1;
        }
      }else{
        // 左移
        if((endX-startX)/puzzleItemElW<-1.5){
          baseIndex = baseIndex - 2;
        }else if((endX-startX)/puzzleItemElW<-0.5){
          baseIndex = baseIndex - 1;
        }
      };
      if(endY-startY>0){
        // 下移
        if((endY-startY)/puzzleItemElH>2.5){
          baseIndex = baseIndex + this.puzzleSize[0]*3;
        }else if((endY-startY)/puzzleItemElH>1.5){
          baseIndex = baseIndex + this.puzzleSize[0]*2;
        }else if((endY-startY)/puzzleItemElH>0.5){
          baseIndex = baseIndex + this.puzzleSize[0]*1;
        }
      }else{
        // 上移
        if((endY-startY)/puzzleItemElH<-2.5){
          baseIndex = baseIndex - this.puzzleSize[0]*3;
        }else if((endY-startY)/puzzleItemElH<-1.5){
          baseIndex = baseIndex - this.puzzleSize[0]*2;
        }else if((endY-startY)/puzzleItemElH<-0.5){
          baseIndex = baseIndex - this.puzzleSize[0]*1;
        }
      };
      if(baseIndex>=0&&baseIndex<this.puzzleSize[0]*this.puzzleSize[1])
      if(this.puzzleSelectStartIndex!==baseIndex){
        // 与已选item不为同一个，进行替换操作
        let cacheAContent = this.puzzleItemList[this.puzzleSelectStartIndex].content;
        let cacheAIndex = this.puzzleItemList[this.puzzleSelectStartIndex].index;
        let cacheBContent = this.puzzleItemList[baseIndex].content;
        let cacheBIndex = this.puzzleItemList[baseIndex].index;
        this.puzzleItemList[this.puzzleSelectStartIndex].content = cacheBContent;
        this.puzzleItemList[this.puzzleSelectStartIndex].index = cacheBIndex;
        this.puzzleItemList[baseIndex].content = cacheAContent;
        this.puzzleItemList[baseIndex].index = cacheAIndex;
      }
      this.$nextTick(()=>{
        this.puzzleSelectStartIndex = 0;
        // 检查成果
        this.checkResult();
      });
    },
    checkResult(){
      let pass = true;
      this.puzzleItemList.map((item,index)=>{
        if(index!==item.index){
          pass = false;
        }
      });
      if(pass){
        this.gamePlaying = false;
        this.gameEndTime = new Date().getTime();
        clearInterval(this.gameTimer);
        // 发起游戏结束请求
        let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
        let userCache = localStorage.getItem('mobile_musicwow_app_wx_user');
        if(!tokenCache||!userCache){
          return false;
        }
        let userCacheJSON = JSON.parse(userCache);
        let uid = String(userCacheJSON.user_id||'');
        if(!uid){
          return false;
        }
        this.$ajax({
          headers: {
            "X-DEVICE-TYPE": "4",
            "X-APP-NAME": "musicwow",
            "Content-Type": "application/json",
            "YW-TOKEN":tokenCache
          },
          url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/finish`,
          method: "post",
          params:{
            puzzle_id: this.puzzleId,
            channel: this.orgId,
            s:this.resultEncode(this.gameEndTime - this.gameStartTime,'0000000000000000'.slice(0,16-uid.length)+uid)
          }
        }).then((res) => {
          if (res.data.error_code === 0) {
            this.gameResult = {
              time: ((this.gameEndTime - this.gameStartTime)/1000).toFixed(3),
              per:res.data.data.defeat,
              best_time: res.data.data.rank.score,
              best_rank: res.data.data.rank.rank,
              is_lottery: res.data.data.is_lottery,
              user_played_number: res.data.data.user_played_number,
            }
            if(!res.data.data.is_pass){
              this.gameStep = 3;
            }else{
              this.gameStep = 2;
            }
          }else{
            this.$toast(res.data.message);
          }
        });
      }
    },
    resultEncode(data,key){
      let d = String(data);
      let k = CryptoJS.enc.Utf8.parse(key);
      const cipher = CryptoJS.AES.encrypt(d, k, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv:k
      });
      const base64Cipher = cipher.ciphertext.toString(CryptoJS.enc.Base64);
      return base64Cipher;
    },
    toPage(i){
      this.$emit('update:pageStep',i);
    },
    openSubscribeDialog(){
      this.subscribeDialogVisible = true;
    },
    hideSubscribeDialog(){
      this.subscribeDialogVisible = false;
    },
  }
}
</script>
<style lang="scss" scoped>
.page-game{
  min-height: 100vh;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/bg.png);
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  text-align: center;
  .share-btn{
    width: 45px;
    height: auto;
    position: fixed;
    top:15px;
    right:15px;
    z-index: 10000;
  }
  .shadow-tips-wrap{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index: 10000000;
    background-color: rgba(0,0,0,0.5);
    text-align: right;
    .arrow-wrap{
      text-align: right;
      position: relative;
      .arrow{
        width: 240px;
      }
      .tips{
        position: absolute;
        bottom:40px;
        right:35px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
  .ready-wrap{
    .top-title{
      width: 335px;
      height: auto;
      margin: -4px auto 0 auto;
    }
    .complete-img{
      width: 338px;
      height: auto;
      display: block;
      margin: -20px auto 0 auto;
    }
    .start-btn{
      width: 223px;
      height: auto;
      margin:-25px auto 0 auto;
      z-index: 1000000;
      position: relative;
      img{
        width: 100%;
        height: auto;
      }
    }
    .bottom-tips{
      font-size: 14px;
      color: #fff;
      line-height: 20px;
      margin-top: -12px;
      text-align: center;
    }
    .bottom-btn{
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .btn{
        display: flex;
        align-items: center;
        margin:0 16px;
        p{
          font-size: 12px;
          color: #fff;
        }
        img{
          margin-right: 2px;
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .playing-wrap{
    .tools-bar{
      display: flex;
      padding:15px 17px;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .time{
        flex: 1;
        font-size: 26px;
        line-height: 37px;
        text-shadow: 0px 2px 10px  rgba(40, 62, 0, 1);
        color: rgba(253, 231, 25, 1);
        .white{
          font-size: 48px;
          line-height: 56px;
          color: #fff;
        }
      }
      .music-wrap{
        width: 40px;
        height: 40px;
        position: relative;
        &.active{
          .border{
            display: none;
          }
          .music-btn{
            animation: musicPlaying 3s infinite linear;
          }
        }
        .border{
          width: 34px;
          height: auto;
          display: block;
          position: absolute;
          top:8px;
          left:4px;
          z-index: 10;
        }
        .music-btn{
          width: 40px;
          height: 40px;
        }
      }
    }
    .center-wrap{
      border: 5px solid #fff;
      width: 300px;
      height: 428px;
      overflow: hidden;
      margin: 0 auto;
      .complete-image{
        width: 100%;
        height: 100%;
      }
      .puzzle-wrap{
        position: relative;
        width: 300px;
        height: 428px;
        .puzzle-item{
          width: 33.33%;
          height: 25%;
          display: inline-block;
          vertical-align: top;
          position: relative;
          .content{
            height: 100%;
          }
          .shadow-img{
            position: absolute;
            top:0;
            left:0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 100;
            background: #333;
          }
        }
      }
    }
    .bottom-btn{
      width: 240px;
      margin: 18px auto 0 auto;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .result-wrap{
    .wow{
      display: block;
      width: 200px;
      height: auto;
      margin:0 auto;
    }
    .banner{
      width: 320px;
      height: auto;
      margin: -52px auto 0 auto;
      z-index: 100;
    }
    .content-wrap{
      border-radius: 30px;
      background: rgba(0, 78, 44, 0.55);
      border: 2px solid rgba(255, 255, 255, 1);
      margin:-50px 18px 0 18px;
      padding:48px 25px 12px 25px;
      .result{
        font-size: 25px;
        line-height: 43px;
        color: #fff;
        margin-bottom: 3px;
      }
      .per{
        font-size: 14px;
        color: #fff;
        margin-bottom: 14px;
        .yellow{
          color: rgba(255, 217, 0, 1);
        }
      }
      .rank-wrap{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        .item{
          border-radius: 20px;
          padding:10px 0;
          width: 128px;
          margin:0 7px;
          color: #fff;
          font-size: 14px;
          line-height: 20px;
          &.l{
            background: rgba(72, 188, 96, 1);
          }
          &.r{
            background: rgba(188, 192, 37, 1);
          }
          .num{
            font-size: 24px;
          }
        }
      }
      .red-tips{
        margin-bottom: 6px;
        font-size: 14px;
        color: rgba(255, 108, 11, 1);
        line-height: 20px;
      }
      .again-btn{
        width: 290px;
        margin:0 auto;
        img{
          width: 100%;
          height:  auto;;
        }
      }
      .chance-number{
        font-size: 16px;
        color: #fff;
        line-height: 23px;
        .yellow{
          color: rgba(255, 217, 0, 1);
        }
      }
    }
    .bottom{
      margin-top: 16px;
      display: flex;
      justify-content: center;
      .btn{
        width: 170px;
        height: 68px;
      }
    }
    .focus-wrap{
      margin-top: 24px;
      img{
        width: 160px;
        height: auto;
      }
      p{
        color: #fff;
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
}
@keyframes musicPlaying {
  0%{
    transform: rotate(0);
  }
  50%{
    transform: rotate(180deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>